const hasRealTags = (text) => /<[a-zA-Z]/.test(text);
const hasEscapedTags = (text) => /&lt;\/?[a-zA-Z]/.test(text);

const unescapeEntities = (text) => {
  if (typeof document === "undefined") {
    return text
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, "&");
  }
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
};

export const formatRichText = (value) => {
  if (value == null || value === "") return "";
  let text = String(value);

  if (hasEscapedTags(text) && !hasRealTags(text)) {
    text = unescapeEntities(text);
  }

  if (!/<(br|p|div|li|ul|ol)\b/i.test(text)) {
    text = text.replace(/\r\n|\r|\n/g, "<br>");
  }

  return text;
};
